<style lang="less" scoped>
  .product-section {
    padding: 40px 0;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px 0 40px;
  }
  .title {
    font-size: 18px;
  }
  .header-right {
    display: flex;
    align-items: center;
    margin-left: auto;
  }
  .order-select {
    width: 120px;
  }
  .select {
    width: 160px;
    margin-left: 5px;
  }
  .search-icon {
    width: 30px;
    height: 100%;
    background-image: url(~@/assets/icon-search-s.png);
    background-size: 15px;
    background-position: center;
    background-repeat: no-repeat;
  }
  .input {
    width: 160px;
    margin-left: 5px;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    // margin: 20px -20px -10px -20px;
    // padding: 0 40px;
  }
  .product-item-wrapper {
    // width: calc((100% - 240px) / 6);
    width: 230px;
    margin: 10px 20px;
  }
</style>

<style lang="less">
  .sc-management-products-header-select {
    input.el-input__inner {
      background-color: #fff;
    }
  }
</style>

<template lang="pug">
  section.product-section
    header.header
      p.title 전체 상품 관리
      .header-right
        el-select.order-select(v-model="order", size="small")
          el-option(value="default", label="등록순")
          el-option(value="click", label="클릭순")
          el-option(value="favor", label="관심상품순")
          el-option(value="price-desc", label="가격높은순")
          el-option(value="price-asc", label="가격낮은순")
        el-cascader.input(
          v-model="categoryOptions",
          size="small",
          class="no-guid-input",
          separator=">",
          :options="categories")
        el-input.input(
          v-model="keyword",
          size="small",
          placeholder="검색",
          @keyup.enter.native="searchKeyword")
          .search-icon(slot="suffix")
    .content
      .product-item-wrapper(v-for="product in products", :key="product.prodSeq")
        product-item(
          :product="product",
          :categories="categories",
          :noPadding="true",
          :edit="edit"
          @modify="productModify"
        )
    .pager
      el-pagination(
        background,
        layout="prev, pager, next",
        @current-change="paging",
        :page-size="ps",
        :total="rows",
        :current-page.sync="pg",
      )
</template>

<script>
import { mapState } from 'vuex';
import ProductItem from '@/components/ProductItem.vue';
import ProductListDialog from '@/components/ProductListDialog.vue';

export default {
  components: {
    ProductItem,
    ProductListDialog,
  },
  watch: {
    categoryOptions(value) {
      this.cateSeq = `${value[1]}`;
      this.paging(1);
    },
    order() {
      this.paging(1);
    },
    queryPg(value) {
      this.paging(parseInt(value, 10));
    },
  },
  computed: {
    ...mapState({
      me: state => state.me,
      categories: state => state.categories,
      query: state => state.route.query,
      queryPg: state => state.route.query.pg,
    }),
  },
  data() {
    return {
      rows: 0,
      pg: 1,
      ps: 60,
      visible: false,
      fixedSet: 1,
      edit: true,
      products: null,
      cateSeq: '',
      order: 'default',
      categoryOptions: ['', ''],
      keyword: '',
    };
  },
  async mounted() {
    if (this.query.pg !== undefined) {
      this.pg = parseInt(this.query.pg, 10);
    }
    this.paging(this.pg);
  },
  methods: {
    async paging(value) {
      const { path } = this.$route;
      const query = { ...this.$route.query };
      query.pg = value;

      this.pg = value;
      const product = await this.$http.get(
        '/api/mkc/v1/products',
        {
          params: {
            ps: this.ps,
            pg: this.pg,
            cseqs: this.cateSeq,
            sort: this.order,
            sw: this.keyword,
          },
        },
      );
      this.products = product.data.data;
      this.rows = product.data.meta.total;

      this.$router.push({ path, query });
      window.scrollTo(0, 0);
    },
    searchKeyword() {
      this.paging(1);
    },
    async productModify(prodSeq, name, category) {
      await this.$http.post(`/api/mkc/v1/products/${prodSeq}`, { prodName: name, prodGender: category[0], cateSeq: category[1] });
    },
  },
};
</script>
